module.exports = __webpack_public_path__ + "static/media/acms-project.515f7b6d.svg";